// extracted by mini-css-extract-plugin
export var activityContainer = "_j1-0";
export var typingIndicatorContainer = "_j1-1";
export var typingIndicatorDot = "_j1-2";
export var wave = "_j1-3";